export default __webpack_public_path__ + "static/media/loader.659df565.gif";